import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getCALLASSIGNTableStructure";
export const UPDATE_TABLE_DATA = "getCALLASSIGNTableData";
export const EXPORT_TABLE_DATA = "exportCALLASSIGNTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setCALLASSIGNTableStructure";
export const SET_TABLE_DATA = "setCALLASSIGNTableData";
export const SET_TABLE_FILTER = "setCALLASSIGNTableFilter";
export const SET_FILTER_CHANGE = "setCALLASSIGNFilterChange";
export const SET_TABLE_PAGE = "setCALLASSIGNTablePage";
export const SET_TABLE_PERPAGE = "setCALLASSIGNTablePerPage";
export const SET_TABLE_SORTBY = "setCALLASSIGNTableSortBy";
export const SET_TABLE_SORTORDER = "setCALLASSIGNTableSortOrder";
export const SET_EXPORT_LINK = "setCALLASSIGNExportLink";

const state = {
  queryObject: {},
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  /**
   * for table title, descripton
   * */
  getCALLASSIGNTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getCALLASSIGNTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getCALLASSIGNTableState(state) {
    return state.table_state;
  },
  getCALLASSIGNTableHeaders(state) {
    return state.table_structure.columns;
  },

  getCALLASSIGNTableFilters(state) {
    return state.table_structure.filters;
  },

  getCALLASSIGNTableData(state) {
    return state.table_data.data;
  },

  getCALLASSIGNExportUrl(state) {
    return state.export_link;
  },
  getCALLASSIGNAgents(state) {
    // console.log(state, state.table_structure.call_statuses[0]);
    return state.table_structure.agents;
  },
  getCALLASSIGNstatistics(state) {
    // console.log(state, state.table_structure.call_statuses[0]);
    return state.table_structure.statistics;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/customer_service/call_assignments")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/customer_service/call_assignments/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/customer_service/call_assignments/export", payload)
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    // console.log("order state of filter update", filter);
    state.table_state.filters = filter;
  },

  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
